import { render, staticRenderFns } from "./CommunicationPreview.vue?vue&type=template&id=a63a189a"
import script from "./CommunicationPreview.vue?vue&type=script&lang=ts"
export * from "./CommunicationPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports